import { render } from "./index.vue?vue&type=template&id=4553fa4a&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "/app/10119217139/workspace/IBU-IFSP_PUBLIC/IBU-IFSP-OPENAPI/OPENAPI_WEB_PORTAL_BUILD_GKE_DIRECT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__